
import React, { useState, useEffect } from "react";
import { Modal, Input } from "antd";
import { useTranslation } from "react-i18next";

const DocLicenseNoModal = ({ visible, onClose, onSubmit, showLinkField, initialLink }) => {
  const [licenseNo, setLicenseNo] = useState("");
  const [link, setLink] = useState(initialLink || "");
  const { t } = useTranslation();
  useEffect(() => {
    if (visible) {
      setLicenseNo("");
      setLink(initialLink || "");
    }
  }, [visible, initialLink]);

  const handleOk = () => {
    if (!licenseNo.trim()) {
      alert(t("Lütfen licenseNo girin."));
      return;
    }
    onSubmit?.({ licenseNo, link: link || "" });
  };

  return (
    <Modal
      open={visible}
      title={
        <div className="w-full text-center text-base font-semibold">
          {t("licenseNoSelection")}
        </div>
      }
      onCancel={onClose}
      onOk={handleOk}
      okText={t("Kaydet")}
      cancelText={t("İptal")}
      okButtonProps={{ style: { backgroundColor: "#1890ff", borderColor: "#1890ff", color: "white" } }}
      cancelButtonProps={{ style: { color: "#ff4d4f", borderColor: "#ff4d4f" } }}
      destroyOnClose
      maskClosable={false}
    >
      <div className="flex flex-col gap-4">
        <label className="text-sm text-gray-700" htmlFor="licenseNoInput">{t("Enter LicenseNo")}
        </label>
        <Input
          id="licenseNoInput"
          value={licenseNo}
          onChange={(e) => setLicenseNo(e.target.value)}
          autoFocus
          allowClear
        />
      </div>
    </Modal>
  );
};

export default DocLicenseNoModal;




